exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lar_form_row .form_section_title[data-v-62979e05] {\n  font-size: 20px;\n  margin: 10px 0 25px;\n  font-family: \"PingFangTC-Medium\";\n  font-weight: normal;\n}", ""]);

// exports
